module.exports = __webpack_public_path__ + "static/phone.738745ed.png";